module.exports = __webpack_public_path__ + "static/media/designPic.932e67cc.png";